import {Box, Text, Badge} from "@chakra-ui/react"

const MentionDropdown = ({showList, filteredVariables, selectedIndex, selectVariable, prefix = '#', selectKey = 'display', showProvider = false}) => {
    if (!showList || filteredVariables.length === 0) return null

    return (
        <Box
            position="absolute"
            top="100%"
            left="0"
            width="full"
            zIndex="1000"
            bg="gray.800"
            borderWidth="1px"
            borderColor="border.secondary"
            borderRadius="md"
            mt="2"
            maxH="200px"
            overflowY="auto"
            boxShadow="lg"
        >
            {filteredVariables.map((v, i) => (
                <Box
                    key={v.id}
                    px="4"
                    py="2"
                    display={showProvider ? 'flex' : 'block'}
                    flexDirection={showProvider ? 'row' : undefined}
                    columnGap={showProvider ? 2 : undefined}
                    cursor="pointer"
                    bg={i === selectedIndex ? "gray.900" : "transparent"}
                    _hover={{bg: "gray.700"}}
                    onMouseDown={(e) => {
                        e.preventDefault()
                        selectVariable(v[selectKey])
                    }}
                >
                    <Text color="gray.500" fontSize="sm" fontWeight="medium">
                        {prefix}{v.display}
                    </Text>
                    {showProvider && v.provider && (
                        <Badge variant={'subtle'} colorPalette={'cyan'} fontSize={11}>{v.provider}</Badge>
                    )}
                </Box>
            ))}
        </Box>
    )
}

export default MentionDropdown;
